import React from "react";
import styles from "./ConstructionTable.module.scss";
import {type ConstructionTableBodyProps, type ConstructionTableProps} from "./ConstructionTableProps";
import ConstructionTableHeader from "./ConstructionTableHeader";
import ConstructionTableRowChooser from "./ConstructionTableRowChooser";

const ConstructionTable: React.FunctionComponent<ConstructionTableProps> = ({
  constructionId,
  constructionElementsName,
  constructionPartItems,
  isAccepted,
}) => {
  if (constructionPartItems === undefined || constructionPartItems === null || constructionPartItems.length === 0) {
    return null;
  }
  const headers = Object.keys(constructionPartItems[0]);
  const values = Object.values(constructionPartItems);
  return (
    <div className={styles.constructionDetailsTableContainer}>
      <table>
        <ConstructionTableHeader
          constructionElementsName={constructionElementsName}
          constructionElementPropertyHeaders={headers}
        />
        <ConstructionTableBody
          constructionId={constructionId}
          constructionElementsName={constructionElementsName}
          constructionPartItems={values}
          isAccepted={isAccepted}
        />
      </table>
    </div>
  );
};

const ConstructionTableBody: React.FunctionComponent<ConstructionTableBodyProps> = ({
  constructionId,
  constructionElementsName,
  constructionPartItems,
  isAccepted,
}) => {
  return (
    <ConstructionTableRowChooser
      constructionId={constructionId}
      constructionElementsName={constructionElementsName}
      constructionPartItems={constructionPartItems}
      isAccepted={isAccepted}
    />
  );
};

export default ConstructionTable;
